<template>
    <div id="bp_intro" class="vw-100">
        <div class="container">
            <div class="row mb-5 mt-5 pb-5 pt-5">
                <div class="col-12 col-lg-9">
                    <h5 class="copy-heading-sub"><b>{{ component.content.label }}</b></h5>
                    <h2 class="copy-heading" v-html="component.content.title"></h2>
                    <p v-for="( copy, ind ) in component.content.copy" :key="ind">{{ copy }}</p>
                </div>
            </div>
            <div 
                :class="[ 'row content-parent', ind / 2 ? '' : 'flex-row-reverse mt-5 pt-5' ]"
                v-for="( teamMember, ind ) in component.team"
                :key="ind++"
            >
                <div class="col-12 col-lg-6">
                    <div class="img-parent" :style="{ 'background-image': 'url(' + teamMember.image + ')' }">
                        <div class="img-decals d-none d-md-block"></div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 pt-5">
                    <h3><b>{{ teamMember.name }}</b></h3>
                    <ul class="list-group mb-4 agent-contact">
                        <li 
                            class="list-group-item"
                            v-if="teamMember.email"
                        >
                            <i class="fa-regular fa-envelope icon"></i>
                            <a class="contact-email" :href="'mailTo:' + teamMember.email + '?subject=Agent Website Enquiry'">{{ teamMember.email }}</a>
                        </li>
                        <li 
                            class="list-group-item"
                            v-if="teamMember.phone"
                        >
                            <i class="fa-solid fa-mobile-screen icon"></i>
                            <a class="contact-phone" :href="'tel:' + teamMember.phone.replaceAll( ' ', '' )">{{ teamMember.phone.replaceAll( '+61 2 ', '0' ) }}</a>

                        </li>
                    </ul>
                    <p class="pe-lg-5" v-for="intro in teamMember.intro">{{ intro }}</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    // load assets
	import andrew_image from "../../assets/andrew_perrot.jpg";

    export default( {
        name: "office-intro",
        props: [
            "office-image"
        ],
        data() {
            return {
                component: {
                    content: {
                        label: "About",
                        title: "Welcome to Bellingen Property",
                        copy: [
                            "Buying or selling a home can be a daunting task. This is not something you do every day and you may find yourself asking questions like, will I get the price I want? What is it I want to buy? How long will it take and what do I have to do to get my home ready for sale? Most importantly, how do I choose an Agent, and will they understand my unique home and circumstances?",
                            "Hi, I am Andrew Perrot, founder of Bellingen Property, I have been selling properties in Bellingen for over 10 years. I understand the excitement and challenges around selling your home from the complete sale process including pricing, strategy, timelines, and preparation. Every home is unique, and every homeowner has individual needs and goals, for the sale of their property.",
                            "We help buyers understand their own needs, as well as understanding the local market, different locations, and the transitional process involved in moving to Bellingen - something I have experienced myself.",
                            "If you are looking for an Agent you can talk to, someone who understands what and why a purchaser will buy your home and someone who takes the time - please call me, so we can start the conversation. I will be there with you every step of the way!"
                        ]
                    },
                    team: [
                        {
                            image:  andrew_image,
                            name:   "Andrew Perrot",
                            email:  "andrew@bellingenproperty.com.au",
                            phone:  "+61 2 428195664",
                            intro:  [
                                "Meet Andrew Perrot, founder of Bellingen Property, with over 10 years of experience selling homes in Bellingen. He understands the excitement and concerns that come with selling a property, from the sales process to pricing strategies and preparation. Committed to providing a positive experience, Andrew recognises that each home is unique and that every homeowner has individual goals. If you're seeking an expert who listens and understands what drives buyers, reach out to Andrew today for personalised support in your home-selling journey.",
                            ]
                        },
                    ]
                }
            }
        }
    });
</script>

<style lang="scss" scoped>
    // global vars
    @import "../../scss/vars.one3design.scss";

    // global mixins
    @import "../../scss/mixins.one3design.scss";

    // component styles
    #bp_intro {
        background-color:$color_base;
        padding-bottom:6em;
        padding-top:6em;
        .content-parent {
            margin-top:4em;
            .img-parent {
                @include images( center, cover );
                margin-bottom:2em;
                padding-bottom:111%;
                position:relative;
                .img-decals {
                    background-color:transparent;
                    height:100%;
                    left:-3em;
                    position:absolute;
                    top:-3em;
                    width:100%;
                    &:before {
                        border-top:10px solid $black;
                        border-left:10px solid $black;
                        content:'';
                        height:4em;
                        left:0;
                        position:absolute;
                        top:0;
                        width:4em;
                    }
                    &:after {
                        border-bottom:10px solid $color_main;
                        border-right:10px solid $color_main;
                        bottom:0;
                        content:'';
                        height:4em;
                        position:absolute;
                        right:0;
                        width:4em;
                    }
                }
            }
            .agent-contact {
                .list-group-item {
                    align-items: center;
                    background-color: transparent;
                    border: 0;
                    border-radius: 0;
                    display:grid;
                    grid-template-areas: "icon content";
                    justify-content: start;
                    min-height: 40px;
                    padding:0;
                    text-align:start;
                    .icon {
                        grid-area: icon;
                        margin-right: 1rem;
                    }
                    .contact-email, .contact-phone {
                        color: $black;
                        grid-area: content;
                        flex-grow: 1;
                    }
                }
            }
        }
    }
</style>